module.exports = __webpack_public_path__ + "/img/41faeeaad90b49622f96ae98132ec920.png";